<template>
    <div>            
        <br>
        <center>
            <v-row v-for="item in items" :key="item.dayname" >
                <v-btn @click="read_data( item.date)"  >{{item.dayname}} {{item.date}}</v-btn>
            </v-row>

        </center>
        <br>
        <v-card height="400px">
            <longdo-map :zoom="12" :lastView="false" >   
                <longdo-map-marker
                    v-for="(item, i) in markers"
                    :key="i"
                    :location="item.location"
                    :title="item.title"
                    :detail="item.detail"
                />
            </longdo-map>
        </v-card>
    </div>
</template>

<script>
    import { LongdoMap } from 'longdo-map-vue'
    LongdoMap.init('bc9689f8772e5fbdd243e1c430d49aba')

    export default {
        name: 'maporder',
        components: {    
        LongdoMap   
        },
        data() {
            return {
                markers: [],
                items:[],
                markers1: [
                    {
                    location: { lon: 100.58, lat: 13.761 },
                    title: "Vue Marker",
                    detail: "This is a detail"
                    },

                ],
            }
        },
    created () {
        this.read_day()
        console.log(' read '+this.markers)
    },

    methods :{
        read_day() {
                const vm = this;
                vm.axios.get('https://ws.plantifulbkk.shop/get_date_week.php').then(response => {
                var result = JSON.parse(JSON.stringify(response.data))
                vm.items = result
            });
        },
        read_data( date) {
                const vm = this;
                vm.markers = null

                vm.axios.get("https://ws.plantifulbkk.shop/get_customer_map.php",{
                    params: {
                        scode: date ,
                    }
                }).then(response=>{
                    var result = JSON.parse(JSON.stringify(response.data))
                    vm.markers = result
                    });
            
        },
        refr_data(){
            this.read_data()
        },
        onClickMarker(){

            alert('click =>')

        },
    }    
}

</script>



// WEBPACK FOOTER //
// src/pages/maporder.vue